import * as Types from '../index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PaymentPhoneFragment = { __typename?: 'PhonesEntity', id: string, value: string, type: Types.PhoneType };

export type PaymentAddressFragment = { __typename?: 'AddressEntity', id: string, lineOne: string, lineTwo?: string | null, city: string, state: string, zip: string, type: Types.AddressType };

export type GetPaymentsByTaxYearInterviewIdQueryVariables = Types.Exact<{
  taxYearInterviewId: Types.Scalars['String'];
  includeDeleted?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type GetPaymentsByTaxYearInterviewIdQuery = { __typename?: 'Query', paymentsByTaxYearInterviewId: Array<{ __typename?: 'PaymentsEntity', id: string, firmAccountId?: string | null, referralFee?: number | null, preparerFee?: number | null, discountApplied?: number | null, totalDollarAmount?: number | null, paymentProcessorFee?: number | null, entityId?: string | null, taskId?: string | null, taxYearInterviewId?: string | null, paymentProcessorId?: string | null, paidOffline?: boolean | null, completedAt?: any | null, deletedAt?: any | null, status?: string | null, requestAt?: any | null, promisedAt?: any | null, createAt?: any | null, updateAt?: any | null, paymentIntentId?: string | null, Invoices?: Array<{ __typename?: 'InvoicesEntity', id: string, description: string, priceEach: number, quantity: number, paymentId: string }> | null, Tasks?: { __typename?: 'TaskEntity', id: string } | null, FirmAccount?: { __typename?: 'FirmAccountEntity', id: string, name?: string | null, BusinessInformation?: { __typename?: 'BusinessInformationEntity', id?: string | null, Address?: Array<{ __typename?: 'AddressEntity', id: string, lineOne: string, lineTwo?: string | null, city: string, state: string, zip: string, type: Types.AddressType }> | null, Phones?: Array<{ __typename?: 'PhonesEntity', id: string, value: string, type: Types.PhoneType }> | null } | null, Users?: { __typename?: 'UserEntity', UserInformation?: { __typename?: 'UserInformationEntity', firstName: string, lastName: string, Address?: Array<{ __typename?: 'AddressEntity', id: string, lineOne: string, lineTwo?: string | null, city: string, state: string, zip: string, type: Types.AddressType }> | null, Phones?: Array<{ __typename?: 'PhonesEntity', id: string, value: string, type: Types.PhoneType }> | null } | null } | null } | null, Entity?: { __typename?: 'Entity', Users?: { __typename?: 'UserEntity', UserInformation?: { __typename?: 'UserInformationEntity', firstName: string, lastName: string, Address?: Array<{ __typename?: 'AddressEntity', id: string, lineOne: string, lineTwo?: string | null, city: string, state: string, zip: string, type: Types.AddressType }> | null, Phones?: Array<{ __typename?: 'PhonesEntity', id: string, value: string, type: Types.PhoneType }> | null } | null } | null } | null }> };

export type GetPreparerWithTaxYearInterviewQueryVariables = Types.Exact<{
  taxYearInterviewId: Types.Scalars['String'];
}>;


export type GetPreparerWithTaxYearInterviewQuery = { __typename?: 'Query', taxYearInterviewIncludePreparer: { __typename?: 'TaxYearInterviewEntity', id: string, PreparedUser?: { __typename?: 'PreparedUserEntity', id: string, email: string, UserInformation: { __typename?: 'UserInformationEntity', firstName: string, lastName: string } } | null } };

export type GetClientSecretFromPaymentIntentIdQueryVariables = Types.Exact<{
  paymentIntentId: Types.Scalars['String'];
}>;


export type GetClientSecretFromPaymentIntentIdQuery = { __typename?: 'Query', GetClientSecretFromPaymentIntentId: string };

export type GetConnectAccountIdQueryVariables = Types.Exact<{
  firmAccountId: Types.Scalars['String'];
}>;


export type GetConnectAccountIdQuery = { __typename?: 'Query', GetConnectAccountId: string };

export type GetFirmLogoQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetFirmLogoQuery = { __typename?: 'Query', GetFirmLogo?: { __typename?: 'FirmLogoEntity', base64: string, width: number, height: number } | null };

export const PaymentPhoneFragmentDoc = gql`
    fragment PaymentPhone on PhonesEntity {
  id
  value
  type
}
    `;
export const PaymentAddressFragmentDoc = gql`
    fragment PaymentAddress on AddressEntity {
  id
  lineOne
  lineTwo
  city
  state
  zip
  type
}
    `;
export const GetPaymentsByTaxYearInterviewIdDocument = gql`
    query GetPaymentsByTaxYearInterviewId($taxYearInterviewId: String!, $includeDeleted: Boolean) {
  paymentsByTaxYearInterviewId(
    taxYearInterviewId: $taxYearInterviewId
    includeDeleted: $includeDeleted
  ) {
    id
    firmAccountId
    referralFee
    preparerFee
    discountApplied
    totalDollarAmount
    paymentProcessorFee
    entityId
    taskId
    taxYearInterviewId
    paymentProcessorId
    paidOffline
    completedAt
    deletedAt
    status
    requestAt
    promisedAt
    createAt
    updateAt
    paymentIntentId
    Invoices {
      id
      description
      priceEach
      quantity
      paymentId
    }
    Tasks {
      id
    }
    FirmAccount {
      id
      name
      BusinessInformation {
        id
        Address {
          ...PaymentAddress
        }
        Phones {
          ...PaymentPhone
        }
      }
      Users {
        UserInformation {
          firstName
          lastName
          Address {
            ...PaymentAddress
          }
          Phones {
            ...PaymentPhone
          }
        }
      }
    }
    Entity {
      Users {
        UserInformation {
          firstName
          lastName
          Address {
            ...PaymentAddress
          }
          Phones {
            ...PaymentPhone
          }
        }
      }
    }
  }
}
    ${PaymentAddressFragmentDoc}
${PaymentPhoneFragmentDoc}`;

/**
 * __useGetPaymentsByTaxYearInterviewIdQuery__
 *
 * To run a query within a React component, call `useGetPaymentsByTaxYearInterviewIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentsByTaxYearInterviewIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentsByTaxYearInterviewIdQuery({
 *   variables: {
 *      taxYearInterviewId: // value for 'taxYearInterviewId'
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useGetPaymentsByTaxYearInterviewIdQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentsByTaxYearInterviewIdQuery, GetPaymentsByTaxYearInterviewIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentsByTaxYearInterviewIdQuery, GetPaymentsByTaxYearInterviewIdQueryVariables>(GetPaymentsByTaxYearInterviewIdDocument, options);
      }
export function useGetPaymentsByTaxYearInterviewIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentsByTaxYearInterviewIdQuery, GetPaymentsByTaxYearInterviewIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentsByTaxYearInterviewIdQuery, GetPaymentsByTaxYearInterviewIdQueryVariables>(GetPaymentsByTaxYearInterviewIdDocument, options);
        }
export type GetPaymentsByTaxYearInterviewIdQueryHookResult = ReturnType<typeof useGetPaymentsByTaxYearInterviewIdQuery>;
export type GetPaymentsByTaxYearInterviewIdLazyQueryHookResult = ReturnType<typeof useGetPaymentsByTaxYearInterviewIdLazyQuery>;
export type GetPaymentsByTaxYearInterviewIdQueryResult = Apollo.QueryResult<GetPaymentsByTaxYearInterviewIdQuery, GetPaymentsByTaxYearInterviewIdQueryVariables>;
export const GetPreparerWithTaxYearInterviewDocument = gql`
    query GetPreparerWithTaxYearInterview($taxYearInterviewId: String!) {
  taxYearInterviewIncludePreparer(id: $taxYearInterviewId) {
    id
    PreparedUser {
      id
      email
      UserInformation {
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetPreparerWithTaxYearInterviewQuery__
 *
 * To run a query within a React component, call `useGetPreparerWithTaxYearInterviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreparerWithTaxYearInterviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreparerWithTaxYearInterviewQuery({
 *   variables: {
 *      taxYearInterviewId: // value for 'taxYearInterviewId'
 *   },
 * });
 */
export function useGetPreparerWithTaxYearInterviewQuery(baseOptions: Apollo.QueryHookOptions<GetPreparerWithTaxYearInterviewQuery, GetPreparerWithTaxYearInterviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreparerWithTaxYearInterviewQuery, GetPreparerWithTaxYearInterviewQueryVariables>(GetPreparerWithTaxYearInterviewDocument, options);
      }
export function useGetPreparerWithTaxYearInterviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreparerWithTaxYearInterviewQuery, GetPreparerWithTaxYearInterviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreparerWithTaxYearInterviewQuery, GetPreparerWithTaxYearInterviewQueryVariables>(GetPreparerWithTaxYearInterviewDocument, options);
        }
export type GetPreparerWithTaxYearInterviewQueryHookResult = ReturnType<typeof useGetPreparerWithTaxYearInterviewQuery>;
export type GetPreparerWithTaxYearInterviewLazyQueryHookResult = ReturnType<typeof useGetPreparerWithTaxYearInterviewLazyQuery>;
export type GetPreparerWithTaxYearInterviewQueryResult = Apollo.QueryResult<GetPreparerWithTaxYearInterviewQuery, GetPreparerWithTaxYearInterviewQueryVariables>;
export const GetClientSecretFromPaymentIntentIdDocument = gql`
    query GetClientSecretFromPaymentIntentId($paymentIntentId: String!) {
  GetClientSecretFromPaymentIntentId(paymentIntentId: $paymentIntentId)
}
    `;

/**
 * __useGetClientSecretFromPaymentIntentIdQuery__
 *
 * To run a query within a React component, call `useGetClientSecretFromPaymentIntentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientSecretFromPaymentIntentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientSecretFromPaymentIntentIdQuery({
 *   variables: {
 *      paymentIntentId: // value for 'paymentIntentId'
 *   },
 * });
 */
export function useGetClientSecretFromPaymentIntentIdQuery(baseOptions: Apollo.QueryHookOptions<GetClientSecretFromPaymentIntentIdQuery, GetClientSecretFromPaymentIntentIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientSecretFromPaymentIntentIdQuery, GetClientSecretFromPaymentIntentIdQueryVariables>(GetClientSecretFromPaymentIntentIdDocument, options);
      }
export function useGetClientSecretFromPaymentIntentIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientSecretFromPaymentIntentIdQuery, GetClientSecretFromPaymentIntentIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientSecretFromPaymentIntentIdQuery, GetClientSecretFromPaymentIntentIdQueryVariables>(GetClientSecretFromPaymentIntentIdDocument, options);
        }
export type GetClientSecretFromPaymentIntentIdQueryHookResult = ReturnType<typeof useGetClientSecretFromPaymentIntentIdQuery>;
export type GetClientSecretFromPaymentIntentIdLazyQueryHookResult = ReturnType<typeof useGetClientSecretFromPaymentIntentIdLazyQuery>;
export type GetClientSecretFromPaymentIntentIdQueryResult = Apollo.QueryResult<GetClientSecretFromPaymentIntentIdQuery, GetClientSecretFromPaymentIntentIdQueryVariables>;
export const GetConnectAccountIdDocument = gql`
    query GetConnectAccountId($firmAccountId: String!) {
  GetConnectAccountId(firmAccountId: $firmAccountId)
}
    `;

/**
 * __useGetConnectAccountIdQuery__
 *
 * To run a query within a React component, call `useGetConnectAccountIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectAccountIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectAccountIdQuery({
 *   variables: {
 *      firmAccountId: // value for 'firmAccountId'
 *   },
 * });
 */
export function useGetConnectAccountIdQuery(baseOptions: Apollo.QueryHookOptions<GetConnectAccountIdQuery, GetConnectAccountIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectAccountIdQuery, GetConnectAccountIdQueryVariables>(GetConnectAccountIdDocument, options);
      }
export function useGetConnectAccountIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectAccountIdQuery, GetConnectAccountIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectAccountIdQuery, GetConnectAccountIdQueryVariables>(GetConnectAccountIdDocument, options);
        }
export type GetConnectAccountIdQueryHookResult = ReturnType<typeof useGetConnectAccountIdQuery>;
export type GetConnectAccountIdLazyQueryHookResult = ReturnType<typeof useGetConnectAccountIdLazyQuery>;
export type GetConnectAccountIdQueryResult = Apollo.QueryResult<GetConnectAccountIdQuery, GetConnectAccountIdQueryVariables>;
export const GetFirmLogoDocument = gql`
    query GetFirmLogo($id: String!) {
  GetFirmLogo(id: $id) {
    base64
    width
    height
  }
}
    `;

/**
 * __useGetFirmLogoQuery__
 *
 * To run a query within a React component, call `useGetFirmLogoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFirmLogoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFirmLogoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFirmLogoQuery(baseOptions: Apollo.QueryHookOptions<GetFirmLogoQuery, GetFirmLogoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFirmLogoQuery, GetFirmLogoQueryVariables>(GetFirmLogoDocument, options);
      }
export function useGetFirmLogoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFirmLogoQuery, GetFirmLogoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFirmLogoQuery, GetFirmLogoQueryVariables>(GetFirmLogoDocument, options);
        }
export type GetFirmLogoQueryHookResult = ReturnType<typeof useGetFirmLogoQuery>;
export type GetFirmLogoLazyQueryHookResult = ReturnType<typeof useGetFirmLogoLazyQuery>;
export type GetFirmLogoQueryResult = Apollo.QueryResult<GetFirmLogoQuery, GetFirmLogoQueryVariables>;
export const namedOperations = {
  Query: {
    GetPaymentsByTaxYearInterviewId: 'GetPaymentsByTaxYearInterviewId',
    GetPreparerWithTaxYearInterview: 'GetPreparerWithTaxYearInterview',
    GetClientSecretFromPaymentIntentId: 'GetClientSecretFromPaymentIntentId',
    GetConnectAccountId: 'GetConnectAccountId',
    GetFirmLogo: 'GetFirmLogo'
  },
  Fragment: {
    PaymentPhone: 'PaymentPhone',
    PaymentAddress: 'PaymentAddress'
  }
}